module.exports = __webpack_public_path__ + "img/avatar.794fbb09.svg";